import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const MID = () => {
  return (
    <CardSection id="MID" title="MID">
      <Paragraph>
        텍스트 문자열에서 지정된 위치로부터 지정된 수만큼 문자를 반환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>MID(STRING, VALUE_1, VALUE_2)</Paragraph>
        <Ul>
          <Li>
            <b>STRING</b>은 평가하려는 텍스트 문자열입니다.
          </Li>
          <Li>
            <b>VALUE_1</b>은 시작 위치입니다.
          </Li>
          <Li>
            <b>VALUE_2</b>는 반환할 문자 수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>MID(`School`, 4, 5)</Paragraph>
        <Img src="computeMid" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>STRING</b>은 텍스트 문자열, 텍스트 문자열이 포함된 열 또는
          텍스트 문자열을 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          <b>VALUE</b>는 숫자 값, 숫자 값이 포함된 열 또는 숫자 값을 반환하는
          함수여야 합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
